import React from "react";
import {C} from "../styles";

const MOOD_COLORS = {1: "#E74C3C", 2: "#E67E22", 3: "#F1C40F", 4: "#2ECC71", 5: "#1E6B5E"};

export default function MoodWidget({data, submitting, justVoted, voteError, vote}) {
    if (!data || !data.moods) return null;

    const hasVoted = !!data.userMood;
    const totalVotes = data.total;

    return (
        <div style={{
            backgroundColor: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: 14,
            padding: "16px 18px",
            marginBottom: 16,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10}}>
                <div style={{display: "flex", alignItems: "center", gap: 8}}>
                    <span style={{fontSize: 20}}>🌡️</span>
                    <span style={{fontWeight: 700, fontSize: 15, color: C.text}}>Humeur du jour</span>
                </div>
                {totalVotes > 0 && (
                    <span style={{fontSize: 12, color: C.textMuted}}>
                        {totalVotes} vote{totalVotes > 1 ? "s" : ""}
                    </span>
                )}
            </div>

            {!hasVoted && (
                <p style={{margin: "0 0 10px", fontSize: 13, color: C.textMuted}}>
                    Comment vous sentez-vous aujourd'hui ?
                </p>
            )}

            {justVoted && (
                <p style={{
                    margin: "0 0 10px", fontSize: 13, color: C.primary, fontWeight: 600,
                }}>
                    Merci pour votre participation !
                </p>
            )}

            {!hasVoted && voteError && (
                <p style={{
                    margin: "0 0 10px", fontSize: 13, color: C.danger, fontWeight: 600,
                }}>
                    {voteError}
                </p>
            )}

            {/* Vote buttons */}
            {!hasVoted && (
                <div style={{display: "flex", justifyContent: "center", gap: 6, marginBottom: 4}}>
                    {data.moods.map(m => (
                        <button
                            key={m.level}
                            onClick={() => vote(m.level)}
                            disabled={submitting}
                            style={{
                                border: "none",
                                background: "none",
                                cursor: submitting ? "wait" : "pointer",
                                padding: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 2,
                                opacity: submitting ? 0.5 : 1,
                                transition: "transform 0.15s",
                            }}
                            onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.2)"; }}
                            onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                            title={m.label}
                        >
                            <span style={{fontSize: 32}}>{m.emoji}</span>
                            <span style={{fontSize: 10, color: C.textMuted, whiteSpace: "nowrap"}}>{m.label}</span>
                        </button>
                    ))}
                </div>
            )}

            {/* Results bar */}
            {hasVoted && totalVotes > 0 && (
                <div>
                    <div style={{
                        display: "flex", height: 28, borderRadius: 8, overflow: "hidden",
                        backgroundColor: "#F0F2F0", marginBottom: 8,
                    }}>
                        {data.moods.map(m => {
                            const count = data.results[m.level] || 0;
                            const pct = Math.round((count / totalVotes) * 100);
                            if (pct === 0) return null;
                            return (
                                <div
                                    key={m.level}
                                    title={`${m.label}: ${count} (${pct}%)`}
                                    style={{
                                        width: `${pct}%`,
                                        backgroundColor: MOOD_COLORS[m.level],
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        transition: "width 0.4s ease",
                                        minWidth: pct > 0 ? 24 : 0,
                                    }}
                                >
                                    <span style={{fontSize: 14}}>{m.emoji}</span>
                                </div>
                            );
                        })}
                    </div>

                    {/* Legend */}
                    <div style={{display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap"}}>
                        {data.moods.map(m => {
                            const count = data.results[m.level] || 0;
                            const pct = Math.round((count / totalVotes) * 100);
                            const isUserChoice = data.userMood === m.level;
                            return (
                                <div key={m.level} style={{
                                    display: "flex", alignItems: "center", gap: 3,
                                    fontSize: 12, color: C.textMuted,
                                    fontWeight: isUserChoice ? 700 : 400,
                                    backgroundColor: isUserChoice ? C.primaryLight : "transparent",
                                    padding: isUserChoice ? "1px 6px" : 0,
                                    borderRadius: 10,
                                }}>
                                    <span>{m.emoji}</span>
                                    <span>{pct}%</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {hasVoted && totalVotes === 0 && (
                <p style={{fontSize: 13, color: C.textMuted, fontStyle: "italic", textAlign: "center"}}>
                    Soyez le premier à partager votre humeur !
                </p>
            )}
        </div>
    );
}
